import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Sticky from 'react-stickynode';

// Images
import Logo from "../../../images/logo-white.png"
import Logo1 from "../../../images/logo.png"
import ProductImg1 from "../../../images/product/pic1.jpg"
import ProductImg2 from "../../../images/product/pic2.jpg"
import IconImg1 from "../../../images/icon/contact/icon1.png"
import IconImg2 from "../../../images/icon/contact/icon2.png"
import IconImg3 from "../../../images/icon/contact/icon3.png"

class Header2 extends Component{
	
	componentDidMount() {
		
		// Cart Dropdown 
		var cartBtn = document.getElementById("cartBtn")
        var cartDropdown = document.querySelector(".cart-dropdown")
		
       if (cartBtn && cartDropdown) {
    cartBtn.addEventListener('click', function () {
        cartDropdown.classList.toggle("show");
    });
}
		
		// Search Form Popup
		var searchBtn = document.getElementById("quik-search-btn")
        var searchForm = document.querySelector(".nav-search-bar")
        var closeBtn = document.getElementById("search-remove")
		
       if (searchBtn && searchForm) {
    searchBtn.addEventListener('click', function () {
        searchForm.classList.add("show");
    });
}

if (closeBtn && searchForm) {
    closeBtn.addEventListener('click', function () {
        searchForm.classList.remove("show");
    });
}

        // Mobile Menu sidebar function
        var btn = document.querySelector('.menuicon');
        var nav = document.querySelector('.menu-links');
       
        function toggleFunc() {
            btn.classList.toggle("open");
            nav.classList.toggle("show");
        }

        btn.addEventListener('click', toggleFunc);

        // Mobile Submenu open close function
        var navMenu = [].slice.call(document.querySelectorAll('.menu-links > ul > li'));
        for (var y = 0; y < navMenu.length; y++) {
            navMenu[y].addEventListener('click', function () { menuClick(this) });
        }

        function menuClick(current) {
            const active = current.classList.contains("open")
            navMenu.forEach(el => el.classList.remove('open'));
            
            if(active){
                current.classList.remove('open') 
                console.log("active")
            } else{
                current.classList.add('open');
                console.log("close")
            }
        }
		
    }
	
	render(){
		return(
			<>
				{/* <!-- Header Top ==== --> */}
				<header className="header rs-nav header-transparent">
					<div className="top-bar">
						<div className="container">
							<div className="row d-flex justify-content-between">
								<div className="topbar-left">
									<ul>
										<li><Link to="#"><i className="la la-phone"></i>Call Us (+213) 770 861 517</Link></li>
										<li><Link to="#"><i className="la la-clock"></i>Sunday to Thursday - 9:00am - 6:00pm</Link></li>
										<li><Link to="#"><i className="las la-envelope-open"></i>contact@go-ps.com</Link></li>
									</ul>
								</div>
								<div className="topbar-right">
									<ul>
										{/* <li><Link to="#">History</Link></li> */}
										<li><Link to="contact">Contact Us</Link></li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<Sticky enabled={true} className="sticky-header navbar-expand-lg">
						<div className="menu-bar clearfix">
							<div className="container clearfix">
								{/* <!-- Header Logo ==== --> */}
								<div className="menu-logo">
									<Link to="/"><img src={Logo} alt=""/></Link>
								</div>
								{/* <!-- Mobile Nav Button ==== --> */}
								<button className="navbar-toggler collapsed menuicon justify-content-end" type="button" data-toggle="collapse" data-target="#menuDropdown" aria-controls="menuDropdown" aria-expanded="false" aria-label="Toggle navigation">
									<span></span>
									<span></span>
									<span></span>
								</button>
								{/* <!-- Navigation Menu ==== --> */}
								<div className="menu-links navbar-collapse collapse justify-content-end" id="menuDropdown">
									<div className="menu-logo">
										<Link to="/"><img src={Logo1} alt=""/></Link>
									</div>
									<ul className="nav navbar-nav">	
										<li className="active"><Link to="/">Home</Link>	</li>
										<li ><Link to="#">Industries<i className="fa fa-chevron-down"></i></Link>
											<ul className="sub-menu">
												<li className="add-menu-left">
													<ul>
														<li><Link to="IndustryOilGas"><span>Oil & Gas (Onshore / Offshore)</span> </Link></li>
														<li><Link to="Electrical&Power"><span>Electrical, Power & Automation Services</span></Link></li>
														<li><Link to="IndustryPetrochemicals"><span>Petrochemicals</span></Link></li>
														<li><Link to="IndustryWaterDesalination"><span>Water treatment and Desalination</span></Link></li>
														<li><Link to="IndustryMining"><span>Mining</span></Link></li>
														<li><Link to="IndustryPowerRenewables"><span>Power & Renewable Energies</span></Link></li>
													</ul>
												</li>
											</ul>
										</li>
										<li className="has-mega-menu "><Link to="#">Solutions<i className="fa fa-chevron-down"></i></Link>
											<ul className="mega-menu">
											<li><Link to="#">Oil & Gas </Link>
										
													<ul>
														<li>
															<Link to="/SolutionGeologicalReservoirAnalysis">
																<span>Geological & Reservoir Analysis</span>
															</Link>
														</li>

														<li>
															<Link to="/SolutionGeophysicalServices">
																<span>Reservoir Stimulation & Activation</span>
															</Link>
														</li>

														<li>
															<Link to="/SolutionDrillingEngineering">
																<span>Well Care: Bottomhole & Surface Cleaning</span>
															</Link>
														</li>

														<li>
															<Link to="/SolutionProductionOptimization">
																<span>Real-Time Well Monitoring</span>
															</Link>
														</li>

														<li>
															<Link to="/SolutionRenewableEnergy">
																<span>Advanced Production Optimization (AI & Nanotechnology)</span>
															</Link>
														</li>

														<li>
															<Link to="/SolutionIndustrialMaintenance">
																<span>Equipment & Chemical Supply for Drilling & Production</span>
															</Link>
														</li>
													
												
											</ul>
											</li>
											<li><Link to="#">Electrical & Power Engineering Services</Link>
										
													<ul>
                                                        <li>
															<Link to="/SolutionEnergy">
																<span>Electrical  Engineering</span>
															</Link>
														</li>
														 <li>
															<Link to="/SolutionEnergy">
																<span>Automation, SCADA & Digital Energy</span>
															</Link>
														</li> 
														<li>
															<Link to="/SolutionProductionOptimization">
																<span>Real-Time Well Monitoring</span>
															</Link>
														</li>

														<li>
															<Link to="/SolutionTrainingCompetency">
																<span>Mechanical, Electrical & Cryogenic Maintenance</span>
															</Link>
														</li>
													
													
												
											</ul>
											</li>
											<li><Link to="#">Project Management & Lifecycle Support</Link>
										
													<ul>

														<li>
															<Link to="/SolutionSupplyChainLogistics">
																<span>Facility Support & Problem Resolution</span>
															</Link>
														</li>

														<li>
															<Link to="/SolutionEnvironmentalHSE">
																<span>Wells & Facilities Integrity Management</span>
															</Link>
														</li>

													
													
												
											</ul>
											</li>
											</ul>
										</li>
										<li className="has-mega-menu "><Link to="/contact">Contact us </Link>
										</li>
									</ul>
								</div>
								{/* <!-- Navigation Menu END ==== --> */}
							</div>
						</div>
					</Sticky>
				</header>
				<div className="contact-sidebtn close">
					<i className="ti-close"></i>
				</div>
			</>
		);
	}
}

export default Header2;
